import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Footer from "./Layout/Footer";

function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [nextPage, setNextPage] = useState(null);
  const [loadingMore, setLoadingMore] = useState(false);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://dashboard.maineautoparts.com/api/posts");
      setPosts(response.data.data || []);
      setNextPage(response.data.next_page_url);
    } catch (error) {
      console.error("Error fetching posts:", error);
    } finally {
      setLoading(false);
    }
  };

  const loadMore = async () => {
    if (!nextPage || loadingMore) return;
    setLoadingMore(true);
    try {
      const response = await axios.get(nextPage);
      const newPosts = response.data.data || [];
      setPosts((prev) => [...prev, ...newPosts]);
      setNextPage(response.data.next_page_url);
    } catch (error) {
      console.error("Error loading more posts:", error);
    } finally {
      setLoadingMore(false);
    }
  };

  // Helper to remove HTML tags for blog excerpts
  const stripHtml = (html) => {
    if (!html) return "";
    return html.replace(/<[^>]*>?/gm, "");
  };

  return (
    <div>
      <div className="main-container container page" style={{ marginTop: "30px", marginBottom: "60px" }}>
        <ul className="breadcrumb">
          <li>
            <Link to="/">
              <i className="fa fa-home"></i>
            </Link>
          </li>
          <li>
            <Link to="/blog">Blog</Link>
          </li>
        </ul>

        <div className="row">
          <div className="col-md-12">
            <h2 className="astra-text" style={{ marginBottom: "30px", textAlign: "center" }}>
              Our Latest Blog Posts
            </h2>
          </div>
        </div>

        {loading ? (
          <div className="text-center" style={{ padding: "50px" }}>
            <span className="spinner-border text-primary" role="status"></span>
            <p>Loading posts...</p>
          </div>
        ) : posts.length === 0 ? (
          <div className="text-center" style={{ padding: "50px" }}>
            <h3>No blog posts available.</h3>
          </div>
        ) : (
          <div>
            <div className="row">
              {posts.map((post) => (
                <div key={post.id} className="col-md-4 col-sm-6" style={{ marginBottom: "30px" }}>
                  <div className="card" style={{ border: "1px solid #eee", borderRadius: "8px", overflow: "hidden", height: "100%", display: "flex", flexDirection: "column" }}>
                    <div style={{ height: "200px", overflow: "hidden", backgroundColor: "#f9f9f9" }}>
                      <img
                        src={post.image ? `https://dashboard.maineautoparts.com/storage/${post.image}` : "/image/catalog/logo.png"}
                        alt={post.title}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      />
                    </div>
                    <div className="card-body" style={{ padding: "15px", flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                      <div>
                        <span style={{ fontSize: "12px", color: "#999" }}>
                          {new Date(post.created_at).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          })}
                        </span>
                        <h4 style={{ margin: "10px 0", fontSize: "18px", lineHeight: "1.4" }}>
                          <Link to={`/blog/${post.slug}`} style={{ color: "#1D2348", fontWeight: "bold" }}>
                            {post.title}
                          </Link>
                        </h4>
                        <p style={{ fontSize: "14px", color: "#666", display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {stripHtml(post.body)}
                        </p>
                      </div>
                      <div style={{ marginTop: "15px" }}>
                        <Link to={`/blog/${post.slug}`} className="btn btn-primary" style={{ backgroundColor: "#e06027", borderColor: "#e06027", padding: "6px 15px", fontSize: "14px" }}>
                          Read More
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {nextPage && (
              <div className="text-center" style={{ marginTop: "20px", marginBottom: "40px" }}>
                <button className="btn btn-secondary" onClick={loadMore} disabled={loadingMore} style={{ padding: "10px 25px" }}>
                  {loadingMore ? "Loading..." : "Load More Posts"}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default Blog;
